import React from "react";

const Filler = () => {
    return (
        <div className={"filler"}/>
    );
};

export default Filler;